'use strict';
var $ = jQuery;

var _calc = {

	init: function () {
		_calc.setCalcs();
	},

	runPowCalc: function(powEls){
		var inputError = false, ACpower, powerVA, energy_AC = false,bill = false;
		ACpower = (powEls.tf.val() * powEls.vol.val() * powEls.cur.val() * powEls.cphi.val() * powEls.qty.val()).toFixed(0);
		powerVA = (ACpower/powEls.cphi.val()).toFixed(0);
		if(powEls.time.val() && powEls.nd.val()){
			energy_AC = (powEls.time.val() * ACpower * powEls.nd.val() / 1000).toFixed(2);
			bill= (energy_AC * powEls.cost.val()).toFixed(2);
		}

		if(!inputError){
			$("#power").text(ACpower);
			$("#power_va").text(powerVA);
		}

	},
	runEnCalc: function(powEls,enEls){
		var inputError = false, ACpower, powerVA, energy_AC = false,bill = false;
		ACpower = (powEls.tf.val() * powEls.vol.val() * powEls.cur.val() * powEls.cphi.val() * powEls.qty.val()).toFixed(0);
		powerVA = (ACpower/powEls.cphi.val()).toFixed(0);
		if(enEls.time.val() && enEls.nd.val()){
			energy_AC = (enEls.time.val() * ACpower * enEls.nd.val() / 1000).toFixed(2);
			bill= (energy_AC * enEls.cost.val()).toFixed(2);
		}

		if(!inputError){
			if(energy_AC) $("#energy_ac").text(energy_AC);
			if(bill) $("#bill").text(bill);
		}
	},
	setCalcs: function(){
		var powEls = {
			form: $("#powCalc"),
			tf  : $('#trifactor'),
			vol : $('#voltage'),
			cur : $('#current_AC'),
			qty : $('#qty'),
			cphi: $('#cosphi'),
			time: $('#time'),
			nd: $('#number_days'),
			cost: $('#cost_kwh')
		};
		var enEls = {
			form: $("#enCalc"),
			time: $('#time'),
			nd: $('#number_days'),
			cost: $('#cost_kwh')
		};
		$.validator.addMethod("digitsonly", function(value, element) {
			return this.optional(element) || /^[0-9.]+$/i.test(value);
		}, "Digits only");
		powEls.vol.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9]/, optional: true}}});
		powEls.cur.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		powEls.qty.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9]/, optional: true}}});
		powEls.cphi.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		enEls.time.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		enEls.nd.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
		enEls.cost.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});

		powEls.form.validate({
			rules: {
				"voltage": {
					digitsonly: true,
					required: true
				},
				"current_AC": {
					digitsonly: true,
					required: true
				},
				"qty": {
					digitsonly: true,
					required: true
				},
				"cosphi": {
					digitsonly: true,
					required: true
				}
			},
			submitHandler: function(form) {
				form.preventDefault;
				_calc.runPowCalc(powEls);
				return false;
			}
		});
		enEls.form.validate({
			rules: {
				"time": {
					digitsonly: true,
					required: true
				},
				"number_days": {
					digitsonly: true,
					required: true
				},
				"cost_kwh": {
					digitsonly: true,
					required: true
				}
			},
			submitHandler: function(form) {
				form.preventDefault;
				_calc.runEnCalc(powEls,enEls);
				return false;
			}
		});
	}
};

$(document).ready(_calc.init);